import { render, staticRenderFns } from "./recordDetail1.vue?vue&type=template&id=ca68b9ea&scoped=true&"
import script from "./recordDetail1.vue?vue&type=script&lang=js&"
export * from "./recordDetail1.vue?vue&type=script&lang=js&"
import style0 from "./recordDetail1.vue?vue&type=style&index=0&id=ca68b9ea&lang=scss&scoped=true&"
import style1 from "./recordDetail1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca68b9ea",
  null
  
)

export default component.exports